import React from 'react';
import Button from '../../../components/ui/Button';
import { Link } from 'react-router-dom';

const FormActions = ({ onSubmit, onReset, isSubmitting, isValid }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex flex-col sm:flex-row gap-4 justify-end">
        <Link to="/member-list">
          <Button variant="outline" fullWidth className="sm:w-auto">
            Cancelar
          </Button>
        </Link>
        
        <Button
          variant="secondary"
          onClick={onReset}
          disabled={isSubmitting}
          fullWidth
          className="sm:w-auto"
          iconName="RotateCcw"
          iconPosition="left"
        >
          Limpar formulário
        </Button>
        
        <Button
          variant="default"
          onClick={onSubmit}
          loading={isSubmitting}
          disabled={!isValid || isSubmitting}
          fullWidth
          className="sm:w-auto"
          iconName="UserPlus"
          iconPosition="left"
        >
          {isSubmitting ? 'Cadastrando...' : 'Cadastrar membro'}
        </Button>
      </div>
      
      <div className="mt-4 text-center">
        <p className="text-xs text-muted-foreground">
          Todos os campos marcados com <span className="text-error">*</span> são obrigatórios
        </p>
      </div>
    </div>
  );
};

export default FormActions;